const SPRINT = {
  title: 'Sprint',
  titleList: 'Liste des 6 derniers sprints',
  dates: 'Affichage du {debut} au {fin}',
  addEdit: {
    titleAdd: 'Ajouter un sprint',
    titleEdit: 'Modifier un sprint',
    titre: 'Titre',
    sprint: 'Sprint',
    dateAffichage: 'Date d\'affichage',
    dateRetraitHomePage: 'Date de retrait',
    addSprintSuccess: 'Le sprint a été ajouté avec succès',
    editSprintSuccess: 'Le sprint a été modifié avec succès',
    deleteSprintSuccess: 'Le sprint a été supprimé avec succès',
    updateSprintConfirmation: 'La modification du sprint se répercutera sur tous les clients d\'affixe',
  },
  actions: {
    add: 'Ajouter un sprint',
  },
};

export default SPRINT;
